/**
 * @global
 * @namespace
 */
const BasicModeration = (function ()
{

	function hide(endpoint, warning)
	{
		_showWarningAndExecuteGetEndpoint(endpoint, warning);
	}

	function show(endpoint, warning)
	{
		_showWarningAndExecuteGetEndpoint(endpoint, warning);
	}

	function lockChallenge(endpoint, warning)
	{
		_showWarningAndExecuteGetEndpoint(endpoint, warning);
	}

	function unlockChallenge(endpoint, warning)
	{
		_showWarningAndExecuteGetEndpoint(endpoint, warning);
	}

	function lockIdea(endpoint, warning)
	{
		_showWarningAndExecuteGetEndpoint(endpoint, warning);
	}

	function unlockIdea(endpoint, warning)
	{
		_showWarningAndExecuteGetEndpoint(endpoint, warning);
	}

	function pinIdea(endpoint)
	{
		_executeGetEndpoint(endpoint, function ()
		{
			mvvm.doSubmit(null, "__RESET", null, null, null);
		});
	}

	function unpinIdea(endpoint)
	{
		_executeGetEndpoint(endpoint, function ()
		{
			mvvm.doSubmit(null, "__RESET", null, null, null);
		});
	}

	function _showWarningAndExecuteGetEndpoint(endpoint, warning, success)
	{
		showConfirmPopup(warning, function ()
		{
			_executeGetEndpoint(endpoint, function ()
			{
				mvvm.doSubmit(null, "__RESET", null, null, null);
			});
		});
	}

	function _executeGetEndpoint(endpoint, success)
	{
		dataAction.callClientGetEndpoint(
			endpoint,
			success,
			_errorHandler,
		);
	}

	function _errorHandler(error)
	{
		showErrorPopup(error.responseJSON.message);
	}

	return {
		hide: hide,
		show: show,
		lockChallenge: lockChallenge,
		unlockChallenge: unlockChallenge,
		lockIdea: lockIdea,
		unlockIdea: unlockIdea,
		pinIdea: pinIdea,
		unpinIdea: unpinIdea,
	};
}());